import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';


const CSVJSONConverter = () => {
  const [csv, setCsv] = useState('');
  const [json, setJson] = useState('');
  const [error, setError] = useState('');

  const handleCsvChange = (e) => {
    setCsv(e.target.value);
  };

  const handleConvert = () => {
    try {
      const csvRows = csv.trim().split('\n');
      const headers = csvRows.shift()?.split(',');
      const jsonData = csvRows.map((row) => {
        const values = row.split(',');
        return headers?.reduce((obj, header, index) => {
          obj[header.trim()] = values[index]?.trim(); // Trim spaces
          return obj;
        }, {}) || {};
      });
      setJson(JSON.stringify(jsonData, null, 2));
      setError('');
    } catch (error) {
      setError('Invalid CSV format');
    }
  };

  const handleJsonChange = (e) => {
    setJson(e.target.value);
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(json).then(() => {
      alert('JSON copied to clipboard!'); // Feedback for copying
    }).catch(() => {
      alert('Failed to copy JSON!'); // Feedback for failure
    });
  };

  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">CSV to JSON Converter      </h1>
      <div className="row">
        <div className="col-md-6 mb-3">
          <h2 className="h5 mb-2">CSV input</h2>
          <textarea
            className="form-control"
            rows={10}
            value={csv}
            onChange={handleCsvChange}
            placeholder= "Enter CSV data here"
          />
        </div>
        <div className="col-md-6 mb-3">
          <h2 className="h5 mb-2">JSON output          </h2>
          <textarea
            className="form-control"
            rows={10}
            value={json}
            onChange={handleJsonChange}
            placeholder="The JSON data will appear here."
            readOnly
          />
        </div>
      </div>
      <div className="d-flex justify-content-center mb-3">
        <button
          className="btn btn-primary me-2"
          onClick={handleConvert}
        >
          Convert
        </button>
        <button
          className="btn btn-success"
          onClick={handleCopy}
        >
        Copy JSON
        </button>
      </div>
      {error && (
        <div className="alert alert-danger">{error}</div>
      )}
    </div>
  );
};

export default CSVJSONConverter;
